import React , { useEffect } from 'react';

// MUI
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment';

// MUI Icons
import ErrorIcon from '@mui/icons-material/Error';

function CustomTextField (props) {

    const { errorText, error,portLogin, ...rest } = props

    // On mount
    useEffect(() => {
        
        return () => {
            // Clean up
        }
    }, [])

    return (
        <TextField
            style={{marginTop: '5px'}}
            error={error}
            helperText={error ? errorText : null}
            FormHelperTextProps={{error: error}}
            InputProps={{
                endAdornment: error ? <InputAdornment position='end'><ErrorIcon color='error'/></InputAdornment> : null,
                readOnly: portLogin ? true : false
            }}
            {...rest}
        />
    )
}

// Export
export default CustomTextField
